import React, { PropsWithChildren } from 'react';

import { Col } from '@opendoor/atoms/box';

export const ContentWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return <Col className="max-w-full rounded-2xl">{children}</Col>;
};
